import { useState } from "react";
import { motion } from "framer-motion";

const optionVariants = {
  hidden: { opacity: 0, y: 18 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: 0.25 + i * 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const QuizStep = ({ question, onAnswer }) => {
  const [picked, setPicked] = useState(null);

  const choose = (letter) => {
    if (picked) return;
    setPicked(letter);
    setTimeout(() => onAnswer(letter), 420);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 48 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -48 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      className="px-6 max-w-md mx-auto w-full"
    >
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold"
      >
        Domanda {String(question.id).padStart(2, "0")}
      </motion.p>
      <motion.h2
        data-testid="question-text"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        className="mt-3 font-serif text-[1.7rem] leading-snug text-ink"
      >
        {question.text}
      </motion.h2>

      <div className={`mt-10 ${question.visual ? "space-y-7" : "divide-y divide-line border-y border-line"}`}>
        {question.options.map((opt, i) =>
          question.visual ? (
            <motion.button
              key={opt.letter}
              custom={i}
              variants={optionVariants}
              initial="hidden"
              animate="show"
              onClick={() => choose(opt.letter)}
              data-testid={`q${question.id}-option-${opt.letter}`}
              className={`block w-full text-left transition-opacity duration-300 ${
                picked && picked !== opt.letter ? "opacity-30" : "opacity-100"
              }`}
            >
              <div className={`overflow-hidden ${picked === opt.letter ? "ring-1 ring-gold" : ""}`}>
                <img
                  src={opt.image}
                  alt={opt.text}
                  loading="lazy"
                  className={`w-full aspect-[4/3] object-cover transition-transform duration-700 ${
                    picked === opt.letter ? "scale-105" : ""
                  }`}
                />
              </div>
              <div className="mt-3 flex items-baseline gap-3">
                <span className="font-mono text-xs text-gold">{opt.letter}</span>
                <span className="font-serif italic text-lg text-ink">{opt.text}</span>
              </div>
            </motion.button>
          ) : (
            <motion.button
              key={opt.letter}
              custom={i}
              variants={optionVariants}
              initial="hidden"
              animate="show"
              onClick={() => choose(opt.letter)}
              data-testid={`q${question.id}-option-${opt.letter}`}
              className={`flex w-full items-start gap-4 py-6 text-left transition-all duration-300 active:bg-blush-soft ${
                picked === opt.letter ? "bg-blush-soft" : ""
              } ${picked && picked !== opt.letter ? "opacity-30" : "opacity-100"}`}
            >
              <span className="mt-1 font-mono text-xs text-gold">{opt.letter}</span>
              <span className="text-base leading-relaxed text-ink">{opt.text}</span>
            </motion.button>
          )
        )}
      </div>
    </motion.div>
  );
};
